import { useState } from 'react';
import QrReader from '@components/qr-reader';

const Component = () => {
  const [result, setResult] = useState({});
  console.log(result);
  return (
    <>
      <QrReader onScanSuccess={setResult} />
      <div>{result.data}</div>
    </>
  );
};

const path = '#qr-reader';
const label = 'Test';

const description = 'Page de test';

const Page = { Component, path, label, description };
export default Page;
